import {styled} from '@mui/system'

export const FlexColumnStyled = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
})

export const SlotSelector = styled('div')({
  display: 'flex',
  flex: 1,
  gap: '8px',
  '& > *': {
    flex: 1,
    minWidth: 0,
  },
})

export const SlotSelectorContainer = styled('div')({
  display: 'flex',
  alignItems: 'flex-end',
  gap: '8px',
  '.ant-select': {
    width: '100%',
    minWidth: '80px',
    '.ant-select-selector': {
      height: '40px !important',
      borderRadius: '8px !important',
      display: 'flex !important',
      alignItems: 'center !important',
      '.ant-select-selection-placeholder': {
        lineHeight: '1',
      },
      '.ant-select-selection-item': {
        lineHeight: '1',
      },
      '.ant-select-selection-overflow': {
        position: 'absolute',
        '.ant-select-selection-item': {
          borderRadius: '4px',
        },
      },
    },
  },
})

export const FormStyle = styled('form')({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
})
